/** 不同请求服务的环境配置 */
export const serviceConfig: Record<ServiceEnvType, Record<string, string>> = {
  dev: {
    url: 'http://10.40.12.203:8040',
    // url: 'https://service.1198.cn',
  },
  test: {
    url: 'http://10.40.12.203:8040',
  },
  prod: {
    // url: 'http://10.40.12.203:8040',
    url: 'https://service.1198.cn',
  },
}
